<template>
  <div>
    <v-container max-width="2500" style="max-width: 3000px !important;">
      <v-card class="mx-auto my-5" max-width="2500">
        <v-system-bar class="py-5 px-3 system-bar-title" style="color: #fff" dark>
          Carga KtV
        </v-system-bar>
      </v-card>
     <!--  <v-card class="mx-auto my-5 elevation-1" max-width="2100">
        <v-row justify="center">
          <v-col cols="12" sm="8" md="6">
            <v-file-input v-model="files" label="Seleccionar archivos" multiple accept=".xlsx"></v-file-input>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="6">
           
          </v-col>
          <v-card-actions>
            <v-btn
                color="blue darken-1"
                dark
                style="margin: 0 1rem;"
                :disabled="files.length === 0 || uploading"
                @click="handleFileUpload"
              >
                {{ uploading ? "Subiendo..." : "Cargar" }}
                
              </v-btn>
            
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>

          </v-card-actions>
        </v-row>
      </v-card> -->
      <v-card class="mx-auto my-5 elevation-1" max-width="2100">
  <v-row justify="center">
    <v-col cols="12" sm="8" md="6">
      <v-file-input v-model="files" label="Seleccionar archivos" multiple accept=".xls"></v-file-input>
    </v-col>
  </v-row>
  <v-row justify="center">
    <v-col cols="12" sm="8" md="6"></v-col>
    <v-card-actions>
      <v-btn
        color="blue darken-1"
        dark
        style="margin: 0 1rem;"
        :disabled="files.length === 0 || uploading"
        @click="handleFileUpload"
      >
        {{ uploading ? "Subiendo..." : "Cargar" }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
    </v-card-actions>
  </v-row>
</v-card>
    </v-container>
  </div>
</template>
<style scoped>
.bg-primary-table {
  /* background: rgb(27 160 255 / 12%); */
  font-weight: 400;
}

.text-start {
  font-size: 0.8rem !important;
}

.container {
  max-width: 3000px !important;
}

.v-label {
  margin-left: 0;
}
::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
  data() {
    return {
      files: [],
      uploading: false,
      valor1: 15,
      valor2: 10,
      ver: false,
      searchIpress: "",
      searchRed: "",
      dataIpress: [],
      dataEnvio: {
        fecha: null,
      },
      dialog: false,
      datos: {
        modalidad_inicio_trr: "",
        fecha_inicio_trr: "",
        subsistema_salud: "",
        tipo_acceso: "",
        fecha_creacion_acceso: "",
        fecha_primer_ingreso: "",
        comorbilidadOtros: "",
      },
      menu1: false,
      menu2: false,
      menu3: false,
      titleButton: "",
      titleCard: "",
      valid: true,
      documento: {
        id_paciente: null,
        id_etiologia: null,
        tipo: "",
        numero: "",
        autogenerado: "",
        apellidosNombres: "",
        fecha_nacimiento: "",
        edad: "",
        sexo: "",
        gradoInstruccion: "",
        etiologiaCodigo: "",
        etiologiaGeneral: "",
        etiologiaEspecifica: "",
        enf_otra: "",
        id_usuario_ipress: "",
        id_fecha: "",
      },
      e6: [],
      // Esto es para almacenar las opciones seleccionadas
      cas: null,
      maestro: null,
      deleteUser: [],
      statusEdit: false,
      date: new Date(
        Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date1: new Date(
        Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date2: new Date(
        Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date3: new Date(
        Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      search: "",
      sortBy: [{ key: "codigo_unico", order: "asc" }],
      headers: [
        { text: "Codigo Unic", value: "codigo_unico" },
        { text: "IPRESS", value: "ipress" },
        { text: "Ruc", value: "ruc" },
        { text: "Tipo Inst.", value: "tipo_institucion" },
        { text: "Ubigeo", value: "ubigeo" },
        { text: "Dirección", value: "direccion" },
        { text: "Cod. Disa", value: "codigo_disa" },
        { text: "Disa", value: "disa" },
        { text: "Cod. Red", value: "codigo_red" },
        { text: "Red", value: "red" },
        { text: "Actions", align: "center", value: "actions", sortable: false },
      ],
      dialogEdit: false,
      dialogDelete: false,
      dataCas: [],
      dataMaesto: [],
      isLoading: false,
      itemsTipSex: ["MASCULINO", "FEMENINO"],
      menu1: false,
      menu2: false,
      dataEtiologia: [],
      dataPaciente: [],
      usuario:null,
      nombre:null
    };
  },
  methods: {
    close() {
      this.$emit('closeDialog');
    },
    /* async handleFileUpload() {
      const formData = new FormData();
      formData.append("file", this.files[0]);
      const fileName = this.files[0].name;
      try {
          axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          }).then((response) => {
            this.auth = "Bearer " + response.data.access;
            axios.post
              (
                RUTA_API + "/carga_ktv_archivo/",
                formData,
                {
                  headers:
                    { Authorization: this.auth }
                }
              ).then((res) => {
                this.registroUsuario(fileName);
              }).catch((error) => {
                Swal.fire({
                  title: "¡Error!",
                  text: "¡No se registró correctamente!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                });
              });
          })
          .catch((res) => {
            console.log("Error:", res);
          });
      } catch (error) {
        console.error("Error al enviar el archivo:", error);
      }
    }, */
    async handleFileUpload() {
  const formData = new FormData();
  
  // Agregar todos los archivos seleccionados al FormData
  this.files.forEach(file => {
    formData.append("files", file);
  });

  try {
    // Obtener el token de autenticación
    const authResponse = await axios.post(RUTA_API + "/api/token/", {
      username: USUARIO,
      password: PASSWORD,
    });

    this.auth = "Bearer " + authResponse.data.access;

    // Enviar los archivos al backend
    const uploadResponse = await axios.post(RUTA_API + "/carga_ktv_archivo/", formData, {
      headers: {
        Authorization: this.auth,
        "Content-Type": "multipart/form-data" // Importante para enviar archivos
      }
    });

    // Manejo de la respuesta del backend
    if (uploadResponse.status === 200) {
      this.registroUsuario(this.files.map(file => file.name).join(", "));
      Swal.fire({
        title: "¡Éxito!",
        text: "Los archivos se han cargado correctamente.",
        icon: "success",
        confirmButtonText: "Aceptar"
      });
    } else {
      throw new Error("Error en la carga de archivos");
    }

  } catch (error) {
    console.error("Error al subir los archivos:", error);
    Swal.fire({
      title: "¡Error!",
      text: "¡No se registraron los archivos correctamente!",
      icon: "error",
      confirmButtonText: "Aceptar"
    });
  }
},
    registroUsuario(fileName){
      axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          }).then((response) => {
            this.auth = "Bearer " + response.data.access;
            axios.post
              (
                RUTA_API + "/registroCarga/",
                {
                  nombre_archivo : fileName,
                  tamano_archivo : 4,
                  tipo_archivo : 'xls',
                  estado : 'Aceptado',
                  detalles : '',
                  usuario:`${this.usuario} |${this.nombre}`,
                },
                {
                  headers:
                    { Authorization: this.auth }
                }
              ).then((res) => {
                Swal.fire({
                  title: "¡Exito!",
                  text: "¡Se registró correctamente!",
                  icon: "success",
                  confirmButtonText: "Aceptar",
                });
                this.close();
              }).catch((error) => {
                Swal.fire({
                  title: "¡Error!",
                  text: "¡No se registró correctamente!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                });
              });
          })
          .catch((res) => {
            console.log("Error:", res);
          });
    },
    uploadFiles() {
      this.uploading = true;
      // Simulating upload process, replace with actual upload logic
      setTimeout(() => {
        // Here you would implement the logic to upload files to your server
        console.log("Files uploaded:", this.files);
        this.uploading = false;
        this.files = []; // Reset files after upload
        this.close();
      }, 2000); // Simulated 2 second delay for demonstration
    },
    uploadData() {
      if (!this.file) return;

      // Aquí puedes agregar la lógica para procesar el archivo
      console.log("Archivo seleccionado:", this.file);
    },
    createOpen() {
      this.clearForm();
      this.titleButton = "Aceptar";
      this.titleCard = "Crear IPRESS";
      this.dialogEdit = true;
    },
    editOpen(item) {
      this.statusEdit = true;
      this.titleButton = "Aceptar";
      this.titleCard = "Editar IPRESS";
      this.dialogEdit = true;
      this.ipressData.user_id = item.url.split("/")[4];
      this.ipressData.codigo_unico = item.codigo_unico;
      this.ipressData.ipress = item.ipress;
      this.ipressData.ruc = item.ruc;
      this.ipressData.tipo_institucion = item.tipo_institucion;
      this.ipressData.ubigeo = item.ubigeo;
      this.ipressData.direccion = item.direccion;
      this.ipressData.codigo_disa = item.codigo_disa;
      this.ipressData.disa = item.disa;
      this.ipressData.codigo_red = item.codigo_red;
      this.ipressData.red = item.red;
      this.ipressData.codigo_microred = item.codigo_microred;
      this.ipressData.microred = item.microred;
      this.ipressData.categoria = item.categoria;
      this.ipressData.telefono = item.telefono;
      this.ipressData.inicio_actividades = item.inicio_actividades;
      this.ipressData.horario_atencion = item.horario_atencion;
    },
    editClose() {
      console.log("reporte paciente", this.ipressData);
      this.clearForm();
      this.statusEdit = false;
      this.dialogEdit = false;
    },
    deleteOpen(item) {
      this.deleteUser = item;
      this.dialogDelete = true;
    },
    deleteClose() {
      this.dialogDelete = false;
    },
    createItem() {
      console.log(this.ipressData.id_user);
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/ipress/", this.ipressData, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              console.log("exito", res.status);
              this.editClose();
              this.dataInit();
              this.clearForm();
              this.dialogEdit = false;
            })
            .catch((res) => {
              console.warn("Error:", res);
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
      /*} else {
        this.dialogEdit = false;
        this.dialogAvisoEditar = true;
      }*/
    },
    editItem() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .patch(
              RUTA_API + "/ipress/" + this.ipressData.user_id + "/",
              this.ipressData,
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              /*               this.dialogDataApi = true; */
              /* this.statusEdit=true; */
              console.log("exito", res.status);
              this.editClose();
              this.dataInit();
              this.clearForm();
              this.statusEdit = false;
              this.dialogEdit = false;
            })
            .catch((res) => {
              console.warn("Error:", res);
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
      /*} else {
        this.dialogEdit = false;
        this.dialogAvisoEditar = true;
      }*/
    },
    deleteItem() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .delete(
              RUTA_API + "/ipress/" + this.deleteUser.url.split("/")[4] + "/",
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              this.dialogDelete = false;
              this.dataInit();
              this.dialogEdit = false;
            })
            .catch((res) => {
              console.warn("Error:", res);
              this.dialogDelete = false;
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    dataInit() {
      this.isLoading = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/ipress/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              console.log("exito", res);
              this.isLoading = false;
              this.dataIpress = res.data;
              /* this.dataIpress.forEach((item) => {
                // Calcula el nombre completo y guárdalo en una nueva propiedad 'nombreCompleto'
                item.descripCas = `${item.datosCasOri.descripCas}`;
                item.descripMaestro = `${item.datosMaestro.descripMaestro}`;
              }); */
            })
            .catch((res) => {
              console.log("Error:", res);
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadEti() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/etiologia/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dataEtiologia = res.data;
            })
            .catch((res) => {
              console.log("Error:", res);
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    updateCodEti() {
      for (const i in this.dataEtiologia) {
        const element = this.dataEtiologia[i];
        // Tu lógica aquí
        if (element.codigo === this.documento.etiologiaCodigo) {
          this.documento.etiologiaGeneral = element.general;
          this.documento.etiologiaEspecifica = element.especifica;
          this.documento.id_etiologia = element.url;
          break;
        }
        if (element.codigo != this.documento.etiologiaCodigo) {
          this.documento.etiologiaGeneral = "";
          this.documento.etiologiaEspecifica = "";
        }
        /*  console.log("pruebas de escritura",this.documento.etiologiaCodigo); */
        /* if(element.codigo!==this.documento.etiologiaCodigo){
          this.documento.etiologiaGeneral="";
          this.documento.etiologiaEspecifica="";
        } */
      }
    },
    loadPaciente() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/paciente/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dataPaciente = res.data;
            })
            .catch((res) => {
              console.log("Error:", res);
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    updatePaciente() {
      for (const i in this.dataPaciente) {
        const element = this.dataPaciente[i];
        // Tu lógica aquí
        if (element.documento == this.documento.numero) {
          this.documento.tipo = element.tipo_documento;
          this.documento.autogenerado = element.autogenerado;
          this.documento.apellidosNombres = element.paciente;
          this.documento.fecha_nacimiento = this.formatDates(
            element.fecha_nacimiento
          );
          this.documento.edad = this.calculateAge(element.fecha_nacimiento);
          this.documento.sexo = element.genero;
          this.documento.gradoInstruccion = element.grado_instruccion;
          this.documento.id_paciente = element.url;
          break;
        }
        if (element.documento != this.documento.numero) {
          this.documento.tipo = "";
          this.documento.autogenerado = "";
          this.documento.apellidosNombres = "";
          this.documento.fecha_nacimiento = "";
          this.documento.edad = "";
          this.documento.sexo = "";
          this.documento.gradoInstruccion = "";
        }
      }
    },
    loadFecha() {
      console.log("fecha de hoy a la misma hora ", this.date);
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/fecha/?search=" + this.date, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              console.log("exito Data fecha", res.data);
              this.documento.id_fecha = res.data[0].url;
            })
            .catch((res) => {
              console.log("Error:", res);
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    formatearFecha(fecha) {
      // Dividir la fecha en partes: año, mes y día
      const partes = fecha.split("-");
      // Crear una nueva fecha con el formato "mm-dd-yyyy"
      const nuevaFecha = new Date(`${partes[1]}/${partes[2]}/${partes[0]}`);
      // Obtener el mes, día y año de la nueva fecha
      const mes = nuevaFecha.getMonth() + 1;
      const dia = nuevaFecha.getDate();
      const año = nuevaFecha.getFullYear();
      // Formatear la fecha en el formato deseado
      return `${mes.toString().padStart(2, "0")}-${dia
        .toString()
        .padStart(2, "0")}-${año}`;
    },
    clearForm() {
      (this.date1 = new Date(
        Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10)),
        (this.date2 = new Date(
          Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10)),
        (this.date3 = new Date(
          Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10)),
        (this.datos = {
          modalidad_inicio_trr: "",
          fecha_inicio_trr: "",
          subsistema_salud: "",
          tipo_acceso: "",
          fecha_creacion_acceso: "",
          fecha_primer_ingreso: "",
          comorbilidadOtros: "",
        });
      this.documento = {
        id_paciente: null,
        id_etiologia: null,
        tipo: "",
        numero: "",
        autogenerado: "",
        apellidosNombres: "",
        fecha_nacimiento: "",
        edad: "",
        sexo: "",
        gradoInstruccion: "",
        etiologiaCodigo: "",
        etiologiaGeneral: "",
        etiologiaEspecifica: "",
        enf_otra: "",
        id_usuario_ipress: "",
        id_fecha: "",
      };
      this.documento.enf_ateroesclerotica_cardiaca = "";
      this.documento.enf_insuficiencia_cardiaca_congestiva = "";
      this.documento.enf_vascular_periferica = "";
      this.documento.enf_cerebro_vascular = "";
      this.documento.enf_cancer = "";
      this.documento.enf_diabetes = "";
      this.documento.enf_hipertension = "";
      this.documento.enf_tuberculosis = "";
      this.e6 = [];
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDates(dateString) {
      const parts = dateString.split("-");
      const day = parts[2];
      const month = parts[1];
      const year = parts[0];
      return `${day}-${month}-${year}`;
    },
    calculateAge(dateString) {
      const parts = dateString.split("-");
      const year = parseInt(parts[0]);
      const month = parseInt(parts[1]) - 1; // Los meses en JavaScript se cuentan desde 0
      const day = parseInt(parts[2]);

      const birthDate = new Date(year, month, day);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    },
    submitForm() {
      this.datos.fecha_inicio_trr = this.date1;
      this.datos.fecha_creacion_acceso = this.date2;
      this.datos.fecha_primer_ingreso = this.date3;
      /* this.loadFecha(); */
      this.dialog = true;
      this.documento.id_usuario_ipress =
        sessionStorage.getItem("idUsuarioIpress");
      const dataEnvio = { ...this.documento, ...this.datos };
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/pacientesDialisis/", dataEnvio, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              Swal.fire({
                title: "¡Exito!",
                text: "¡Se registró correctamente!",
                icon: "success",
                confirmButtonText: "Aceptar",
              });
              console.log("exito", res.status);
              this.dialog = false;
              this.clearForm();
              this.loadFecha();
              this.dialogEdit = false;
            })
            .catch((res) => {
              console.warn("Error:", res);
              Swal.fire({
                title: "¡Error!",
                text: "¡No se pudo registrar el formulario!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
          this.dialog = false;
          Swal.fire({
            title: "¡Error!",
            text: "¡No se registró correctamente!",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
        });
    },
    updateComorbilidad() {
      // Reinicia todos los campos de comorbilidad
      this.documento.enf_ateroesclerotica_cardiaca = "";
      this.documento.enf_insuficiencia_cardiaca_congestiva = "";
      this.documento.enf_vascular_periferica = "";
      this.documento.enf_cerebro_vascular = "";
      this.documento.enf_cancer = "";
      this.documento.enf_diabetes = "";
      this.documento.enf_hipertension = "";
      this.documento.enf_tuberculosis = "";

      // Asigna los valores seleccionados a los campos correspondientes
      for (const comorbilidad of this.e6) {
        switch (comorbilidad) {
          case "Enfermedades Ateroescleróticas cardiacas":
            this.documento.enf_ateroesclerotica_cardiaca = 1;
            break;
          case "Insuficiencia cardíaca congestiva":
            this.documento.enf_insuficiencia_cardiaca_congestiva = 1;
            break;
          case "Enfermedad vascular periférica":
            this.documento.enf_vascular_periferica = 1;
            break;
          case "Accidente cerebro vascular / accidente isquémico transitorio":
            this.documento.enf_cerebro_vascular = 1;
            break;
          case "Cáncer":
            this.documento.enf_cancer = 1;
            break;
          case "Diabetes":
            this.documento.enf_diabetes = 1;
            break;
          case "Hipertensión":
            this.documento.enf_hipertension = 1;
            break;
          case "Tuberculosis":
            this.documento.enf_tuberculosis = 1;
            break;
          default:
            break;
        }
      }
    },
  },
  mounted() { },
  computed: {
    dateFormatted() {
      return this.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      );
    },
    filteredData() {
      if (!this.searchRed && !this.searchIpress) {
        return this.dataIpress;
      }
      let filtered = this.dataIpress;
      if (this.searchIpress) {
        filtered = filtered.filter((item) =>
          item.ipress.toLowerCase().includes(this.searchIpress.toLowerCase())
        );
      }
      if (this.searchRed) {
        filtered = filtered.filter((item) =>
          item.red.toLowerCase().includes(this.searchRed.toLowerCase())
        );
      }
      return filtered;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedDateFormatted1() {
      return this.formatDate(this.date1);
    },
    computedDateFormatted2() {
      return this.formatDate(this.date2);
    },
    computedDateFormatted3() {
      return this.formatDate(this.date3);
    },
    customDateFormat() {
      return (val) => {
        const date = new Date(val);
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        // Asegurarse de que el día y el mes tienen dos dígitos
        day = day < 10 ? "0" + day : day;
        month = month < 10 ? "0" + month : month;

        return `${day}-${month}-${year}`;
      };
    },
    fechaFormateada: {
      get() {
        return this.datos.fecha_creacion_acceso;
      },
      set(value) {
        // Convierte la fecha al formato "dd-mm-yyyy"
        const date = new Date(value);
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        // Asegurarse de que el día y el mes tienen dos dígitos
        day = day < 10 ? "0" + day : day;
        month = month < 10 ? "0" + month : month;

        // Establece la fecha formateada de nuevo en el modelo
        this.datos.fecha_creacion_acceso = `${day}-${month}-${year}`;
      },
    },
  },
  watch: {
    /* date (val) {
        this.dateFormatted = this.formatDate(this.date)
      }, */
  },
  created() {
    /*  this.loadFecha();
     this.loadEti();
     this.loadPaciente();
     this.dataInit(); */
     this.usuario = sessionStorage.getItem("usuario");
     this.nombre = sessionStorage.getItem("nombre");
  },
  components: {},
};
</script>